import { User } from '@/shared/models/user.model';
import { TagInterface } from '@/manager/convocation/interfaces/tag.interface';
import { ProcedencyInterface } from '@/manager/client/interfaces/procedency.interface';

export enum ClientStatus {
    Potential = 1,
    Customer = 2,
}


// filter model
interface ClientFilterInterface {
    panelText: string;
    type?: 'input' | 'ship';
    active?: boolean;
    inputs?: any[];
    ships?: any[];
    selects?: any[];
}

export class ClientFilter implements ClientFilterInterface {
    public panelText!: string;
    public type?: 'input' | 'ship';
    public active?: boolean;
    public inputs?: any[];
    public ships?: any[];
    public selects?: any[];

    constructor() {
        this.type = 'ship';
        this.active = false;
    }
}

export interface ClientInterface {
    merchandising?: boolean;
    powerPackMerchandising?: boolean;
    status?: ClientStatus;
    topLevelPack?: boolean;
    powerPack?: boolean;
    oldTopLevelPack?: boolean;
    user?: User;
    origin?: string;
    profession?: string;
    level_3_certificate?: boolean;
    sendComunications?: boolean;
    nickname?: string;
    affiliate?: boolean;
    note?: any;
    tag: TagInterface[];
    procedency?: ProcedencyInterface;
    tlp?:any;
    pwp?:any;
}

export class Client implements ClientInterface {
    public merchandising?: boolean;
    public powerPackMerchandising?: boolean;
    public status?: ClientStatus;
    public topLevelPack?: boolean;
    public powerPack?: boolean;
    public oldTopLevelPack?: boolean;
    public user: User;
    public origin?: string;
    public profession?: string;
    // tslint:disable-next-line:variable-name
    public level_3_certificate?: boolean;
    public sendComunications?: boolean;
    public nickname?: string;
    public affiliate?: boolean;
    public note?: any;
    public tag: TagInterface[];
    public procedency?: ProcedencyInterface;
    public tlp?:any;
    public pwp?:any;

    constructor() {
        this.user = new User();
        this.tag = [];
    }
}
